module.exports = __webpack_public_path__ + "static/media/logout.8d0c67ef.png";